import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useTheme, type ThemeChoice } from '@/app/providers/ThemeProvider';

const OPTIONS: { value: ThemeChoice; label: string; icon: string }[] = [
  { value: 'light', label: 'Цайвар', icon: 'sun' },
  { value: 'dark', label: 'Бараан', icon: 'moon-stars' },
  { value: 'system', label: 'Системийн тохиргоо', icon: 'display' },
];

export function ThemeToggle() {
  const { choice, setChoice } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const current = OPTIONS.find((o) => o.value === choice) ?? OPTIONS[2]!;

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="ts-toggle-btn"
        onClick={() => setOpen((x) => !x)}
        title={`Дэлгэцийн өнгө: ${current.label}`}
        aria-label="Дэлгэцийн өнгө сонгох"
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <i className={`bi bi-${current.icon}`} />
      </button>
      {open ? (
        <div role="menu" className="ts-menu" aria-label="Дэлгэцийн өнгө">
          {OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              role="menuitemradio"
              aria-checked={opt.value === choice}
              className={clsx('ts-menu-item', opt.value === choice && 'active')}
              onClick={() => {
                setChoice(opt.value);
                setOpen(false);
              }}
            >
              <i className={`bi bi-${opt.icon}`} />
              {opt.label}
              {opt.value === choice ? <i className="bi bi-check2 ts-menu-check" /> : null}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
